<template>
   <div>
      <vx-card>
        <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="(dataPatient?(dataPatient.visitNumber+'_'+dataPatient.patient.name):'Hasil Pemeriksaan PCR')"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"

          @progress="onProgress($event)"
          @startPagination="onStartPagination()"
          @hasPaginated="onHasPaginated()"
          @beforeDownload="onBeforeDownload($event)"
          @hasDownloaded="onHasDownloaded()"
          ref="html2Pdf">
          <section slot="pdf-content" class="pdf-content">
            <section class="report-info">
              <h4 class="title">HASIL PEMERIKSAAN LABORATORIUM PCR</h4>
              <section class="patient-info">
                <table>
                  <tr>
                    <td class="txt">&nbsp;</td>
                    <td colspan="3" style="text-align: right">
                      <label style="font-size=10px"><b>Dokter Penanggung Jawab : {{kaLab}}</b></label>
                    </td>
                  </tr>
                  <tr>
                    <td class="txt">Nama</td>
                    <td class="val">: {{dataPatient.patient?dataPatient.patient.name:''}}</td>
                    <td class="txt">No. Laboratorium</td>
                    <td class="val">: {{dataPatient?dataPatient.visitNumber:''}}</td>
                  </tr>
                  <tr>
                    <td class="txt">No. RM/NIK</td>
                    <td class="val">: {{dataPatient.patient?dataPatient.patient.patientNumber:''}}</td>
                    <td class="txt">Dokter Pengirim</td>
                    <td class="val">: {{dataPatient.physician?dataPatient.physician.name:''}}</td>
                  </tr>
                  <tr>
                    <td class="txt">Tanggal Lahir/Umur</td>
                    <td class="val">: {{dataPatient.patient.dob | formatDate}} / {{dataPatient.patient.dob | calcAge}} TH</td>
                    <td class="txt">Tipe Kunjungan</td>
                    <td class="val">: {{dataPatient.patientType?dataPatient.patientType.name:''}}</td>
                  </tr>
                  <tr>
                    <td class="txt">Jenis Kelamin</td>
                    <td class="val">: {{dataPatient.patient.gender?dataPatient.patient.gender.name:''}}</td>
                    <td class="txt">Ruangan</td>
                    <td class="val">: {{dataPatient.ward?dataPatient.ward.name:''}}</td>
                  </tr>
                  <tr>
                    <td class="txt">Alamat</td>
                    <td class="val">: {{dataPatient.patient?dataPatient.patient.address:''}}</td>
                    <td class="txt">No. Telp</td>
                    <td class="val">: {{dataPatient.patient?dataPatient.patient.phoneNumber:''}}</td>
                  </tr>
                </table>
              </section>

              <hr style="margin-top: 20px;"/>
              <div>
                <label style="margin-left:20px"><b>JENIS PEMERIKSAAN</b></label>
                <label style="margin-left:85px"><b>JENIS SPESIMEN</b></label>
                <label style="margin-left:95px"><b>HASIL</b></label>
                <label style="margin-left:105px"><b>NILAI RUJUKAN</b></label>
              </div>
              <hr/>

              <section class="test-result">
                <table style="width: 100%">
                    <vs-tr>
                        <vs-td class="val1">MOLEKULER</vs-td>
                        <vs-td class="val2">&nbsp;</vs-td>
                        <vs-td class="val3">&nbsp;</vs-td>
                        <vs-td class="val2">&nbsp;</vs-td>
                    </vs-tr>
                    <tbody :key="indextr" v-for="(tr, indextr) in dataPatient.groupTest">
                      <vs-tr :key="indextr1" v-for="(tr1, indextr1) in tr.test" :style="(tr1.outNormal?'color: red;':'')">
                          <vs-td class="val1">{{tr1.name}}</vs-td>
                          <vs-td class="val2">Nasofaring - Orofaring</vs-td>
                          <vs-td class="val3">{{tr1.result}}</vs-td>
                          <vs-td class="val2">{{tr1.measureRanges}}</vs-td>
                      </vs-tr>
                    </tbody>
                  </table>
                  <table style="width: 100%">
                    <tbody>
                      <vs-tr>
                        <vs-td class="val4">Cycle thresholds (CT)</vs-td>
                        <vs-td class="val2">&nbsp;</vs-td>
                        <vs-td class="val3">&nbsp;</vs-td>
                        <vs-td class="val2">&nbsp;</vs-td>
                      </vs-tr>
                      <vs-tr v-for="(tr, indextr) in dataPatient.genTarget">
                        <vs-td class="val4">{{tr.name}}</vs-td>
                        <vs-td class="val5">{{' : '+ tr.result}}</vs-td>
                        <vs-td class="val3">&nbsp;</vs-td>
                        <vs-td class="val2">&nbsp;</vs-td>
                    </vs-tr>
                  </tbody>
                </table>
                </table>
              </section>
              <section class="footer">
                <div style="margin-top: 10px">
                  <label>Keterangan :</label>
                </div>
                <div>
                  <label>PCR SARS COV-2 merupakan pemeriksaan molekuler PCR (Polymerase Chain Reaction) yang mendeteksi materi genetik dari virus SARS COV-2 dari sampel yang diterima. Interpretasi lengkap membutuhkan data klinis & penunjang.</label>
                </div>
                <div style="margin-top: 10px" v-if="dataPatient.groupTest.length > 0 && dataPatient.groupTest[0].test[0].result !== 'Positif'">
                  <label>Catatan :</label>
                </div>
                <div v-if="dataPatient.groupTest.length > 0 && dataPatient.groupTest[0].test[0].result === 'Inkonklusive'">
                  <label>Saran : SWAB Ulang.</label>
                </div>
                <div v-if="dataPatient.groupTest.length > 0 && dataPatient.groupTest[0].test[0].result === 'Negatif'">
                  <label>Hasil PCR Negatif tidak selalu berarti pasien tidak terinfeksi oleh patogen, namun hanya menunjukkan bahwa materi genetik patogen tidak ditemukan didalam sampel.</label>
                </div>
                <div>
                  <td class="txt">{{(dataPatient.visitNote.length > 0 && dataPatient.visitNote[0].noteType==='VALIDATE')?dataPatient.visitNote[0].note:''}}</td>
                </div>
                <table style="width: 800px; margin-top: 20px">
                  <tr>
                    <td class="txt">Tgl Pengambilan Sampel</td>
                    <td class="val">: {{dataPatient.createdAt | formatDate}}</td>
                    <td class="txt1">Diperiksa oleh</td>
                    <td class="val1">: {{dataPatient.testedBy?dataPatient.testedBy.name:''}}</td>
                  </tr>
                  <tr>
                    <td class="txt">Tgl Selesai Pemeriksaan</td>
                    <td class="val">: {{dataPatient.timeVerified2 | formatDate}}</td>
                    <td class="txt1">Diverifikasi oleh</td>
                    <td class="val1">: {{dataPatient.verifiedBy?dataPatient.verifiedBy.name:''}}</td>
                  </tr>
                  <tr>
                    <td class="txt">&nbsp;</td>
                    <td class="val">&nbsp;</td>
                    <td class="txt1">Divalidasi Teknis oleh</td>
                    <td class="val1">: {{dataPatient.verified2By?dataPatient.verified2By.name:''}}</td>
                  </tr>
                </table>
                <div style="display: flex">
                  <div style="margin-left: 100px; width: 200px; display: inline-grid; margin-top: 50px;">
                    <VueQRCodeComponent :text="encId" :size="125" color="#e74c3c" bg-color="gold" error-level="H"></VueQRCodeComponent>
                  </div>
                  <div style="margin-left: 250px; width: 400px; display: inline-grid">
                      <label style="margin-top: 50px">Penanggung Jawab Laboratorium</label>
                      <label style="margin-left: 10px; margin-top: 80px">{{kaLab}}</label>
                      <label style="margin-left: 5px;">{{nip}}</label>
                  </div>
                </div>
              </section>
            </section>
          </section>
        </vue-html2pdf>
      </vx-card>
   </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';
import initialConfig from '@/../initialConfig.js';
import VueQRCodeComponent from 'vue-qrcode-component';
import visit from "@/api/visit";
import CryptoJS from 'crypto-js';

export default {
    data() {
      return {
        dataPatient: {},
        progress: 0,
        generatingPdf: false,
        pdfOption: {
          margin: [0, 0, 10, 10],
        },
        kaLab: (initialConfig?initialConfig.kaLab:''),
        nip: (initialConfig?initialConfig.nip:''),
        pdfDownloaded: false,
        html2PdfX: null,
        optionX: {},
        pdfContentX: null,
        encId: null,
        idselected : ''
      }
    },
    methods: {
      async cetak() {
        await this.html2PdfX().set(this.optionX).from(this.pdfContentX).toPdf().save();
      },
      onProgress(progress) {
        this.progress = progress;
        console.log(`PDF generation progress: ${progress}%`);
      },
      onStartPagination(e) {
        console.log(`PDF has started pagination :`+e);
      },
      onHasPaginated(e) {
        console.log(`PDF has paginated :`+e);
      },
      async onBeforeDownload ({ html2pdf, options, pdfContent }) {
        console.log(`PDF onBeforeDownload :`+JSON.stringify(options));
        //this.html2PdfX = html2Pdf, this.optionX = options, this.pdfContentX = pdfContent;
          /*await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
              const totalPages = pdf.internal.getNumberOfPages()
              for (let i = 1; i <= totalPages; i++) {
                  pdf.setPage(i)
                  pdf.setFontSize(10)
                  pdf.setTextColor(150)
                  pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
              }
          }).save()*/
      },
      onHasDownloaded(blobPdf) {
        this.pdfDownloaded = true;
        console.log(`PDF has downloaded yehey`);
        console.log(blobPdf);
      },
      async findDt() {
        const frm = await visit.getDetailV2(this.idSelected);
        if (frm.data.status) {
          if (!frm.data) {
            this.$router.push({name: 'page-error-404'});
          } else {
            this.dataPatient = frm.data.data[0];
          }
        } else {
          this.$router.push({name: 'page-error-404'});
        }
      }
    },
    components: {
        VueHtml2pdf,
        VueQRCodeComponent,
        CryptoJS,
    },
    mounted() {
      console.log('param :'+JSON.stringify(this.$route.params))
      if (this.$route.params!=null && this.$route.params.id!=null) {
        var ciphertext = (this.$route.params.id+'/'+this.$route.params.id1);
        this.encId = initialConfig.extUrlAccess+ciphertext;

        // Decrypt
        var bytes  = CryptoJS.AES.decrypt(ciphertext, initialConfig.secretChiper);
        this.idSelected = bytes.toString(CryptoJS.enc.Utf8);
        console.log('paramR :'+this.idSelected);
        this.findDt();
      }
    },

  }
  </script>

  <style lang="scss" scoped>
  .pdf-content {
    width: 800px;
    padding-top: 76px;
    //background-image: url("../assets/images/pages/background_report.png") ;

    /* Full height */
    height: 100%;

    /* Center and scale the image nicely */
    background-repeat: no-repeat;
    background-size: cover;
    .title {
      text-align: center;
      margin-top: 10px;
    }
    label {
      font-size: 10px;
    }
    .report-info {
      padding: 85px 50px 0px 50px;
      .patient-info {
        margin-top: 20px;
        font-size: 10px;
      }
      .patient-info td {
          padding: 0 10px 0 10px;
      }
      .patient-info td.txt {
          width: 150px;
      }
      .patient-info td.val {
          width: 220px;
      }
      .test-result td {
        padding: 0 7px 0 7px;
        text-align: center;
        border-bottom: 1px dotted black;
        font-size: 10px !important;
      }
      .test-result td.val1 {
        width: 4%;
        font-weight: bold;
        text-align: left !important;
        padding-left: 25px !important;
      }
      .test-result td.val2 {
        width: 15%;
      }
      .test-result td.val3 {
        width: 3%;
      }
      .test-result td.val4 {
        width: 15%;
        text-align: left !important;
        padding-left: 75px !important;
      }
      .test-result td.val5 {
        width: 15%;
        text-align: left !important;
      }
      .footer {
          font-size: 10px;
      }

      .footer td.txt {
          width: 80px;
      }
      .footer td.txt1 {
          width: 60px;
      }
      .footer td.val {
          width: 90px;
      }
      .footer td.val1 {
          width: 150px;
      }
      .user-details {
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        .user-name {
          margin-bottom: 10px;
          margin-top: 30px;
          flex-shrink: 0;
        }
        .detail-container {
          font-size: 13px;
          flex-shrink: 0;
          &:not(:last-child) {
            margin-bottom: 10px;
          }
          .detail-label {
            font-weight: 600;
            margin-right: 5px;
            font-size: 13px;
          }
        }
      }
      .request-details {
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        .user-name {
          margin-bottom: 10px;
          flex-shrink: 0;
        }
        .detail-container {
          font-size: 13px;
          flex-shrink: 0;
          &:not(:last-child) {
            margin-bottom: 10px;
          }
          .detail-label {
            font-weight: 600;
            margin-right: 5px;
            font-size: 13px;
          }
        }
      }
    }
  }
  </style>
